import { useCallback, useEffect, useRef, useState } from "react"
import { useDispatch } from "react-redux"
import { updateMatch } from "../../../actions/matchs.js"
import { UPDATE_TIMER } from "../../../constants/actionTypes.js"

export function useTimer(match, isInterval = true){

    const dispatch = useDispatch()

    const {idMatch, timer, statusTimer, period} = match

    const [timerValue, setTimerValue] = useState(timer)
    const [periodValue, setPeriodValue] = useState(period)

    const timerId = useRef()

    useEffect(() => {
        setTimerValue(match.timer)
        setPeriodValue(match.period)

        if(isInterval){
            // On clean timerId
            clearTimeout(timerId.current);
            timerId.current = undefined

            // On démarre les secondes
            if(match.statusTimer === 'on'){
                let timeoutId = setInterval(function updateTimer(){
                    setTimerValue(t => t+1)
                }, 1000)

                timerId.current = timeoutId
            }
        }
    }, [isInterval, match.period, match.statusTimer, match.timer])

    useEffect(() => {
        return ()=>{
            if(timerId.current){
                clearTimeout(timerId.current);
                timerId.current = undefined
            }
            
          }
    }, [])

    const activateTimer = (callback) => {
        match.statusTimer === 'on' ? stopTimer(callback) : startTimer(callback)
    }


    const startTimer = (callBDD, lastOnStatus = new Date(), initialMatchTimer = match.timer) => {
        dispatch({type : UPDATE_TIMER, payload : {idMatch : match.idMatch, statusTimer : 'on'}})

        // On sauvegarde en base le timer à son arret et le lastUpdate
        if(callBDD)
            callBDD(idMatch, {lastUpdateStatus : new Date(), statusTimer : 'on'})
    }

    const stopTimer = (callBDD) => {
        dispatch({type : UPDATE_TIMER, payload : {idMatch : match.idMatch, statusTimer : 'off', timer : timerValue}})

        // On sauvegarde en base le timer à son arret et le lastUpdate
        if(callBDD)
            callBDD(idMatch, {timer : timerValue, lastUpdateStatus : new Date(), statusTimer : 'off'})
    }

    const startMatch = (callBDD) => {
        setPeriodValue(0)

         dispatch({type : UPDATE_TIMER, payload : {idMatch : match.idMatch, statusTimer : 'on', lastUpdateStatus : new Date(), period : 0}})

        if(callBDD){
            callBDD(idMatch, {lastUpdateStatus : new Date(), statusTimer : 'on', period : 0})
        }
            
    }

    const stopFirstPeriod = (callBDD) => {

        setPeriodValue(1)
        setTimerValue(0)

        dispatch({type : UPDATE_TIMER, payload : {idMatch : match.idMatch, timer : 0, period : 1, statusTimer : 'off'}})

        if(callBDD)
            callBDD(idMatch, {timer : 0, lastUpdateStatus : new Date(), statusTimer : 'off', period : 1})
    }

    const startSecondPeriod = (callBDD) => {

        setPeriodValue(1)

        dispatch({type : UPDATE_TIMER, payload : {idMatch : match.idMatch, period : 1, statusTimer : 'on'}})

        if(callBDD){
            callBDD(idMatch, {lastUpdateStatus : new Date(), statusTimer : 'on', period : 1})
            match.lastUpdateStatus = new Date()
        }  
    }

    const stopSecondPeriod = (callBDD, homeScore, awayScore) => {
        
        setPeriodValue(2)
        setTimerValue(0)

        dispatch({type : UPDATE_TIMER, payload : {idMatch : match.idMatch, period : 2,  timer : 0, statusTimer : 'off'}})

        if(callBDD)
            callBDD(idMatch, {lastUpdateStatus : new Date(), statusTimer : 'off', period : 2,  timer : 0, homeTeamScore : homeScore, awayTeamScore : awayScore})
    }

    const stopSecondPeriodToNext = (callBDD, homeScore, awayScore) => {
        
        setPeriodValue(3)
        setTimerValue(0)

        dispatch({type : UPDATE_TIMER, payload : {idMatch : match.idMatch, period : 3,  timer : 0, statusTimer : 'off'}})

        if(callBDD)
            callBDD(idMatch, {lastUpdateStatus : new Date(), statusTimer : 'off', period : 3,  timer : 0, homeTeamScore : homeScore, awayTeamScore : awayScore})
    }

    const startPeriod = (period, callBDD) => {
        
        setPeriodValue(period)

        dispatch({type : UPDATE_TIMER, payload : {idMatch : match.idMatch, period, statusTimer : period === 5 ? 'off' : 'on'}})

        if(callBDD){
            callBDD(idMatch, {lastUpdateStatus : new Date(), statusTimer : 'on', period})
            match.lastUpdateStatus = new Date()
        }  
    }

    const stopPeriod = (period, callBDD, homeScore, awayScore) => {
        
        setPeriodValue(period)
        setTimerValue(0)

        dispatch({type : UPDATE_TIMER, payload : {idMatch : match.idMatch, period,  timer : 0, statusTimer : 'off'}})

        if(callBDD)
            callBDD(idMatch, {lastUpdateStatus : new Date(), statusTimer : 'off', period,  timer : 0, homeTeamScore : homeScore, awayTeamScore : awayScore})
    }



    return [
        timerValue, 
        activateTimer, 
        undefined, 
        startMatch, 
        stopFirstPeriod, 
        startSecondPeriod, 
        stopSecondPeriod, 
        periodValue,
        stopSecondPeriodToNext,
        startPeriod,
        stopPeriod
    ]

}